<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "InterestsHome",
  metaInfo: {
    title: "إدارة الاهتمامات",
  },
};
</script>